import { render, staticRenderFns } from "./PublicFormLayout.vue?vue&type=template&id=4fce9c36&scoped=true&"
import script from "./PublicFormLayout.vue?vue&type=script&lang=js&"
export * from "./PublicFormLayout.vue?vue&type=script&lang=js&"
import style0 from "./PublicFormLayout.vue?vue&type=style&index=0&id=4fce9c36&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fce9c36",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VMain } from 'vuetify/lib/components/VMain';
installComponents(component, {VCard,VContainer,VMain})
